// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__zTfrz","Open":"SideDrawer_Open__17-Bs","Close":"SideDrawer_Close__1BhSn","Logo":"SideDrawer_Logo__1qqxz"};